import { PlessViewUtilsSub } from './../../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * アイテム情報取得クラス
 *
 * @export GetGoodsDetailService
 * @class GetGoodsDetailService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetGoodsDetailService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsDetailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: PlessViewUtilsSub.trim(this.vo[0]),
        ItemCode: PlessViewUtilsSub.trim(this.vo[1])
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetGoodsDetailService
   */
  execute(model: KYMW1100Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getGoodsDetail', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsDetailService
   */
  success(data: any): void {
    // Item情報初期化。
    this.model.kymw1100Component.setWindowVisible('ITEM_CHANGE');

    // item情報
    this.model.updateGoodsDatailData(data);

    this.model.updateGoodsCoopList(data);

    this.model.updateGoodsCoopWkList(data);

    // 表示更新(税率切り替えはアイテム切り替えでは初期化しないため、現在編集中の表を取得)
    this.model.setConsumeTaxPrice(this.model.getEditCoopInfoList());

    this.model.updateSpecifications1List(data);

    this.model.updateGoodsAllergenList(data);

    this.model.updateGoodsNutrientInfo(data);

    this.model.updateGoodsEcologyList(data);

    this.model.updateGoodsGWStopList(data);

    this.model.updateContainPackingList(data);

    // 利用生協タブの産地コメント制御
    this.model.kymw1100Component.coopListConsignPriceSpecial();

    // janCodeDivによるインストア採番ボタン制御。
    this.model.kymw1100Component.setItemInstallButton();

    // 「eBASEデータ」ボタンの活性制御を行う。
    this.model.kymw1100Component.setWindowVisible('EBASE');
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
